/*
|--------------------------------------------------------------------------
| ZF CUSTOM CODE
|--------------------------------------------------------------------------
|
| File        : zf-size-info.js
| Description : Displays garment measurements based on the
|               currently selected size variant.
|
| Dependencies:
|   - snippets/zf-size-info.liquid
|   - Product metafield : custom.size_chart
|   - Metaobject        : Size Chart Measurements
|
| Flow:
|   Product
|      ↓
|   custom.size_chart (Metaobject Reference)
|      ↓
|   Size Chart Measurements
|      ↓
|   JSON
|      ↓
|   Display Chest & Length
|
|--------------------------------------------------------------------------
*/

document.addEventListener("DOMContentLoaded", () => {

    /*
    ------------------------------------------------------------
    ZF : Read Size Chart JSON injected by Liquid
    ------------------------------------------------------------
    */

    const zfJson = document.getElementById("zf-size-chart-json");

    if (!zfJson) return;

    /*
------------------------------------------------------------
ZF : Current Size Information

Shared with other ZF modules
(e.g. Size Confirmation Popup)

------------------------------------------------------------
*/

    window.zfSizeInfo = {
        size: null,
        bodyChest: null,
        chest: null,
        length: null
    };

    let zfChart = {};

    try {
        zfChart = JSON.parse(zfJson.textContent);
        window.zfSizeChart = zfChart;
    } catch (error) {
        console.error("ZF Size Info: Invalid JSON.", error);
        return;
    }

    /*
    ------------------------------------------------------------
    ZF : Measurement display container
    ------------------------------------------------------------
    */

    const zfContent = document.getElementById("zf-size-info__content");

    if (!zfContent) return;

    /*
    ------------------------------------------------------------
    ZF : Update measurement text
    Called on:
        - Initial page load
        - Whenever user changes size
    ------------------------------------------------------------
    */

    function zfUpdateMeasurements() {

        /*
        --------------------------------------------------------
        Find currently selected SIZE.
        NOTE:
        Product also contains Color radio buttons.
        Therefore, specifically target the Size option.
        --------------------------------------------------------
        */

        const selectedInput = document.querySelector(
            'input[name="Size"]:checked'
        );

        /*
        --------------------------------------------------------
        No size selected
        --------------------------------------------------------
        */

        if (!selectedInput) {


            zfContent.innerHTML = "Select a size.";

            return;
        }

        /*
        --------------------------------------------------------
        Selected Size
        Example:
            XS
            M
            XL
            2XL
        --------------------------------------------------------
        */

        const size = selectedInput.value.trim();

        /*
        --------------------------------------------------------
        Find measurements from JSON
        --------------------------------------------------------
        */

        const data = zfChart[size];

        /*
        --------------------------------------------------------
        Size not available in JSON
        --------------------------------------------------------
        */

        if (!data) {

            zfContent.innerHTML = "Measurements unavailable.";

            return;
        }

        /*
------------------------------------------------------------
ZF : Update shared size information

Makes the current size available to other
ZF modules such as the Size Confirmation popup.

------------------------------------------------------------
*/

        /*
 ------------------------------------------------------------
 ZF : Support old & new JSON formats
 ------------------------------------------------------------
 */

        const garmentChest =
            data.garment_chest ?? data.chest;

        const garmentLength =
            data.garment_length ?? data.length;

        const bodyChest =
            data.body_chest ?? null;

        /*
        --------------------------------------------------------
        Render measurements
        --------------------------------------------------------
        */

        zfContent.innerHTML = `
    ${bodyChest ? `Fits Chest: <strong>${bodyChest}"</strong><span class="zf-separator">|</span>` : ""}
    Garment ( Chest: <strong>${garmentChest}"</strong><span class="zf-separator">|</span>Length: <strong>${garmentLength}"</strong>)`;
    }

    /*
    ------------------------------------------------------------
    Initial load
    ------------------------------------------------------------
    */

    zfUpdateMeasurements();

    /*
    ------------------------------------------------------------
    Listen for size change
    ------------------------------------------------------------
    */

    document.querySelectorAll(
        'input[name="Size"]'
    ).forEach(input => {

        input.addEventListener("change", () => {

            /*
            Small timeout allows Shopify's
            variant picker to finish updating.
            */

            setTimeout(zfUpdateMeasurements, 20);

        });

    });

});